import axios from "axios";
import {Dispatch} from "redux";
import {UpdateQuicktipActionTypes, updateQuicktipAction} from "../../../types/composer/Quicktip/updateQuicktipTypes";

export const updateQuicktipDataResponce = (id:string, updatedQuicktipData: object): any => {
    return async (dispatch: Dispatch<updateQuicktipAction>) => {
        try {
            dispatch({type: UpdateQuicktipActionTypes.FETCH_QUICKTIP_JACKPOT_DATA});
            const response = await axios({
                method: 'put',
                url: `/api/composer/quicktips/${id}`,
                data: updatedQuicktipData,
                withCredentials: false,
            });
            dispatch({type: UpdateQuicktipActionTypes.FETCH_QUICKTIP_JACKPOT_DATA_SUCCESS, payload: response.data})
        } catch (error: any) {
            let errorMessage = 'Something went wrong. Please try again.';

            if (axios.isAxiosError(error) && error.response && error.response.data && error.response.data.detail) {
                errorMessage = error.response.data.detail.map((err: any) => err.msg).join(' ');
            } else if (axios.isAxiosError(error) && error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            dispatch({
                type: UpdateQuicktipActionTypes.FETCH_QUICKTIP_JACKPOT_DATA_ERROR,
                payload: errorMessage
            });
        }
    }
}

export const clearStateQuicktipUpdateData = () => {

    return (dispatch: Dispatch<updateQuicktipAction>) => {
        dispatch({
            type: UpdateQuicktipActionTypes.CLEAR_STATE_QUICKTIP_UPDATE_DATA_ERROR,
            payload: {}
        });
    };
};